import React, { useState, useEffect } from "react";
import Sidebar from "../../Sidebar/SideBar";
import { Container, Row, Col, Button } from "react-bootstrap";
import './Page1.css';
import { Route, Routes } from "react-router-dom";
import AffliateList from "../AffiliateManager/AffiliateList/AffliateList";
import AddAffliate from "../AffiliateManager/AddAffliate/AddAffliate";
import AffliateReview from "../AffiliateManager/AffiliateReview/AffliateReview";
import CustomNavbar from "../Navbar/Navbar";
import Commission from "../AffiliateManager/Commission/Commission";
import CreateGroup from "../AffiliateManager/CreateGroup/CreateGroup";
import CreateAffliateGroup from "../AffiliateManager/CreateAffiliateGroup/CreateAffliateGroup";
import AffliateGroup from "../AffiliateManager/AffiliateGroup/AffliateGroup";
import PromoReport from "../Reports/PromoReport";
import Summary from "../Reports/Summary";
import FullReport from "../Reports/FullReport";
import UserReport from "../Reports/UserReport";
import Campaigns from "../Marketing/Campaigns";
import AddMedia from "../Marketing/AddMedia";
import MassMedia from "../Marketing/MassMedia";
import MediaList from "../Marketing/MediaList";
import PaymentHitory from "../Payments/PaymentHitory";
import UserInvoice from "../Payments/UserInvoice";
import InvoiceStatus from "../Payments/InvoiceStatus";
import Account from "../Settings/Account";
import CreateUserr from "../Settings/CreateUserr";
import UserList from "../Settings/UserList";
import UserLink from "../Settings/UserLink";
import MarkrtingUserCreate from "../Marketing/MarkrtingUserCreate";
import { useLocation } from 'react-router-dom';
import MainEditPage from "../AffiliateManager/EditAffiliate/MainEditPage/MainEditPage";
import PayBonus from "../AffiliateManager/EditAffiliate/BonusPaid/BonusPaid";
import Group from "../AffiliateManager/EditAffiliate/Groups/Groups";
import Fixedcommissions from "../AffiliateManager/EditAffiliate/FixedCommissions/FixedCommissions";
import PromoCode from "../AffiliateManager/EditAffiliate/PromoCode/PromoCode";
import AffiliateSites from "../AffiliateManager/EditAffiliate/AffiliateSites/AffiliateSites";
import APK from "../AffiliateManager/EditAffiliate/APK/APK";
import DomainSettings from "../AffiliateManager/EditAffiliate/DomainSettings/DomainSettings";
import Footer from "../../Footer/Footer";
import EditCommissionGroup from "../AffiliateManager/EditAffiliate/EditCommissionGroup/EditCommissionGroup";
import EditAffliateGroup from "../AffiliateManager/EditAffiliate/EditAffiliateGroup/EditAffiliateGroup";
import EnableTFA from "../Settings/TFA";
import EditUserr from "../EditUser/EditUser";
import AffiliatePlayers from "../AffiliateManager/EditAffiliate/Players/Players";
import MailingTemplate from "../Settings/MailingTemplates";
import { useSelector } from "react-redux";
import CreateMailingTemplate from "../Settings/CreateMailingTemplate";
import EditMailingContent from "../Settings/EditMailingContent";
import EditCampaign from "../EditCampaign/EditCampaign";
import EditMedia from "../EditMedia/EditMedia";
import Variables from "../Settings/Variables";

function Page1() {
    const location = useLocation();
    const [showSidebar, setShowSideBar] = useState(true);
    const [newStyle, setNewStyle] = useState({});

  
    const userx = useSelector(state => state.user);
      


    return <>
        <div>
            <div>
                <CustomNavbar />
            </div>
            <div>
                <Container className='container-area'>
                    <Row>
                        <div style={{display:"flex"}}>
                            <div className="show-side-btn-wp">
                                {
                                    (location.pathname != "/affiliate/account-settings" && location.pathname != "/affiliate/settings/tfa" && location.pathname != "/affiliate/settings/variables") ? (
                                        <>{showSidebar ? (<i onClick={() => setShowSideBar(!showSidebar)} class="fas fa-chevron-circle-left"></i>) : (<i onClick={() => setShowSideBar(!showSidebar)} class="fas fa-chevron-circle-right"></i>)}</>
                                    ) : (
                                        <></>
                                    )
                                }
                            </div>
                            {showSidebar ? (
                                <>
                                    {
                                        (location.pathname != "/affiliate/account-settings" && location.pathname != "/affiliate/settings/tfa" && location.pathname != "/affiliate/settings/variables") ? (
                                            <div className="sidebar-desktop" >
                                                <Sidebar />
                                            </div>
                                        )
                                            : (<></>)
                                    }
                                </>) : (<></>)}
                            <div className="affiliate-side-content" style={!showSidebar ? { width: "100%" } : {}}>
                                <Routes>

                                    <Route path="/affliateliste" exact element={<AffliateList />} />
                                    <Route path="/add-aff" element={<AddAffliate />} />
                                    <Route path="/affreview" element={<AffliateReview />} />
                                    <Route path="/commission-groups" element={<Commission />} />
                                    <Route path="/commission-create-group" element={<CreateGroup />} />
                                    <Route path="/aff-group" element={<AffliateGroup />} />
                                    <Route path="/create-aff-group" element={<CreateAffliateGroup />} />
                                    <Route path="/details" element={<MainEditPage />} />
                                    <Route path="/details/bonus" element={<PayBonus />} />
                                    <Route path="/details/fixedCommissions" element={<Fixedcommissions />} />
                                    <Route path="/details/group" element={<Group />} />
                                    <Route path="/details/promo" element={<PromoCode />} />
                                    <Route path="/details/affsites" element={<AffiliateSites />} />
                                    <Route path="/details/affApk" element={<APK />} />
                                    <Route path="/details/afflinkdomain" element={<DomainSettings />} />
                                    <Route path="/commission/details" element={<EditCommissionGroup />} />
                                    <Route path="/affliate-group/details" element={<EditAffliateGroup />} />
                                    <Route path="/affiliate-players" element={
                                        <>
                                            {
                                                userx.User != null && userx.User.Permissions == null ? (
                                                    <AffiliatePlayers />
                                                ) : (
                                                    <></>
                                                )
                                            }
                                        </>
                                    }></Route>

                                    <Route path="/summary" element={<Summary />} />
                                    <Route path="/promo-report" element={<PromoReport />} />
                                    <Route path="/full-report" element={<FullReport />} />
                                    <Route path="/player-report" element={<UserReport />} />

                                    <Route path="/marketing/campaigns" element={<Campaigns />} />
                                    <Route path="/marketing/campaign-create" element={<MarkrtingUserCreate />} />
                                    <Route path="/marketing/campaign/details" element={<EditCampaign/>}/>

                                    <Route path="/marketing/add-media" element={<AddMedia />} />
                                    <Route path="/marketing/list-media" element={<MediaList />} />
                                    <Route path="/marketing/media/details" element={<EditMedia/>}/>

                                    <Route path="/payment/history" element={<PaymentHitory />} />
                                    <Route path="/payment/user-invoices" element={<UserInvoice />} />
                                    <Route path="/payment/user-invoices-status" element={<InvoiceStatus />} />
                                    <Route path="/settings/users/details" element={<EditUserr />} />
                                    <Route path="/account-settings" element={<Account />} />
                                    <Route path="/settings/create-user" element={<CreateUserr />} />
                                    <Route path="/settings/user-list" element={<UserList />} />
                                    {/* <Route path="/settings/user-LINK" element={<UserLink />} /> */}
                                    <Route path="/settings/mailing-templates" element={<MailingTemplate />} />
                                    <Route path="/settings/mailing-templates/create" element={<CreateMailingTemplate />}></Route>
                                    <Route path="/settings/mailing-templates/edit" element={<EditMailingContent />}></Route>
                                    <Route path="/settings/tfa" element={<EnableTFA />} />
                                    <Route path="/settings/variables" element={<Variables />} />
                                    <Route path="*" component={() => <h1>404 Not Found</h1>} />
                                </Routes>

                            </div>

                        </div>

                    </Row>

                </Container>

            </div>
        </div>
        <div>
            <Footer />
        </div>
    </>;
}

export default Page1;
